import gsap, { Expo } from 'gsap';
import dayjs from 'dayjs';
import Litepicker from 'litepicker';

class Booking {
    constructor() {
        this.element = document.querySelector('.booking');
        this.closeButton = this.element.querySelector('.booking__close');
        this.reserveButton = document.querySelector('.btn-reserve');

        this.adult = 2;
        this.children = 0;

        this.adultButtonMinus = this.element.querySelector('.adult .booking__value-minus');
        this.adultButtonPlus = this.element.querySelector('.adult .booking__value-plus');
        this.adultSpan = this.element.querySelector('.adult span');

        this.childButtonMinus = this.element.querySelector('.children .booking__value-minus');
        this.childButtonPlus = this.element.querySelector('.children .booking__value-plus');
        this.childrenSpan = this.element.querySelector('.children span');

        this.arrivalPicker = this.element.querySelector('.arrival .booking__value');
        this.arrivalSpan = this.element.querySelector('.arrival span');
        this.arrivalDate = dayjs();

        this.departurePicker = this.element.querySelector('.departure .booking__value');
        this.departureSpan = this.element.querySelector('.departure span');
        this.departureDate = this.arrivalDate.add(1, 'day');

        this.bookingAction = this.element.querySelector('.booking__action');
        this.mobileReserveButton = document.querySelector('.reserve__button');

        this.updateArrivalSpan(this.arrivalDate.format('DD MMM YYYY'));
        this.updateDepartureSpan(this.departureDate.format('DD MMM YYYY'))

        this.initArrivalCalendar();
        this.initDepartureCalendar();

        this.arrivalCalendar.setDate(this.arrivalDate.toDate());
        this.departureCalendar.setDate(this.departureDate.toDate());

        this.updateBookingAction();
        this.initEvents();
    }




    updateArrivalSpan(date) {
        this.arrivalSpan.innerHTML = date;
    }

    updateDepartureSpan(date) {
        this.departureSpan.innerHTML = date;
    }

    createCalendar(pickerEl, dayJsObj, setup) {
        const picker = new Litepicker({
            element: pickerEl,
            format: 'DD/MM/YYYY',
            startDate: dayJsObj.toDate(),
            singleMode: true,
            minDate: dayJsObj.subtract(1, 'day').toDate(),
            numberOfColumns: 1,
            numberOfMonths: 1,
            parentEl: this.element,
            setup,
            buttonText: {
                apply: 'Apply',
                cancel: 'Cancel',
                previousMonth: `
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-left"><polyline points="15 18 9 12 15 6"></polyline></svg>
                `,
                nextMonth: `
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>
            `
            }
        })

        return picker;
    }

    updateBookingAction() {
        const params = new URLSearchParams();
        params.append('tot_camere', 1);
        params.append('tot_adulti', this.adultSpan.innerText);
        params.append('tot_bambini', this.childrenSpan.innerText);
        params.append('gg', this.arrivalDate.get('date'));
        params.append('mm', this.arrivalDate.get('month') + 1);
        params.append('aa', this.arrivalDate.get('year'));

        params.append('ggf', this.departureDate.get('date'));
        params.append('mmf', this.departureDate.get('month') + 1);
        params.append('aaf', this.departureDate.get('year'));

        params.append('id_stile', 18886);
        params.append('id_albergo', 24796);
        params.append('dc', 1119);

        params.append('adulti1', this.adultSpan.innerText);
        params.append('bambini1', this.childrenSpan.innerText);

        params.append('notti_1', this.departureDate.diff(this.arrivalDate, 'days'));

        params.append('lingua_int', 'usa');

        this.bookingAction.setAttribute('href', `https://reservations.villaembrace.com/premium/index2.html?${params.toString()}`)
    }

    initArrivalCalendar() {
        const setup = (picker) => {
            picker.on('selected', (arrivalDate) => {
                this.arrivalDate = dayjs(arrivalDate.dateInstance)
                this.departureCalendar.options.minDate = this.arrivalDate.add(1, 'day').toDate();

                if (this.arrivalDate.diff(this.departureDate, 'days') >= 0) {
                    this.departureDate = dayjs(arrivalDate.dateInstance).add(1, 'day')
                    this.updateDepartureSpan(this.departureDate.format('DD MMM YYYY'));
                    this.departureCalendar.setDate(this.departureDate);
                }

                this.updateArrivalSpan(this.arrivalDate.format('DD MMM YYYY'));
                this.updateBookingAction();
            });
        }

        const picker = this.createCalendar(this.arrivalPicker, this.arrivalDate, setup);

        this.arrivalCalendar = picker;
        this.arrivalSpan.addEventListener('click', () => {
            picker.show();
        })
    }

    initDepartureCalendar() {
        const setup = (picker) => {
            picker.on('selected', (departureDate) => {
                this.departureDate = dayjs(departureDate.dateInstance);

                if (this.departureDate.diff(this.arrivalDate, 'days') <= 0) {
                    this.arrivalDate = dayjs(departureDate.dateInstance).subtract(1, 'day');
                    this.updateArrivalSpan(this.arrivalDate.format('DD MMM YYYY'));
                    this.arrivalCalendar.setDate(this.arrivalDate);
                }

                this.updateDepartureSpan(this.departureDate.format('DD MMM YYYY'));
                this.updateBookingAction();
            });
        }

        const picker = this.createCalendar(this.departurePicker, this.departureDate, setup);

        this.departureCalendar = picker;
        this.departureSpan.addEventListener('click', () => {
            picker.show();
        })
    }

    updateAdultSpan(total) {
        this.adultSpan.innerHTML = total;
        this.updateBookingAction();
    }

    updateChildrenSpan(total) {
        this.childrenSpan.innerHTML = total;
        this.updateBookingAction();
    }

    initEvents() {
        gsap.set(this.element, {
            y: '-100%',
            opacity: 0,
        });

        this.adultButtonMinus.addEventListener('click', () => {
            if (this.adult > 1) {
                this.updateAdultSpan(--this.adult);
            }
        });

        this.adultButtonPlus.addEventListener('click', () => {
            if (this.adult < 10) {
                this.updateAdultSpan(++this.adult);
            }
        });

        this.childButtonMinus.addEventListener('click', () => {
            if (this.children > 0) {
                this.updateChildrenSpan(--this.children);
            }
        });

        this.childButtonPlus.addEventListener('click', () => {
            if (this.children < 10) {
                this.updateChildrenSpan(++this.children);
            }
        });

        this.closeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            gsap.to(this.element, {
                duration: .5,
                y: '-100%',
                opacity: 0,
                ease: Expo.easeIn,
            })
        })

        /**
         * Disabled on this phase
         */
        this.reserveButton.addEventListener('click', () => {
            // gsap.to(this.element, {
            //     duration: .5,
            //     y: '0',
            //     opacity: 1,
            //     ease: Expo.easeOut
            // })
        });



        this.mobileReserveButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            window.location.href = '/contact-us'; return;

            gsap.to(this.element, {
                duration: .5,
                y: '0',
                opacity: 1,
                ease: Expo.easeOut,
            })
        });
    }
}

export default Booking;
